import { configureStore } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';

import listenerMiddleware from 'src/libs/listener.middleware';
import dashboardReducer, { DashboardStore } from './dashboard';

export type AppStore = {
  dashboard: DashboardStore;
};

const store = configureStore({
  reducer: {
    dashboard: dashboardReducer,
  },
  middleware: getDefaultMiddleware => {
    return getDefaultMiddleware().prepend(listenerMiddleware.middleware);
  },
});

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;

export default store;
